/* Supernormal Upgrade — tiny shared behaviours for rebuilt sections.
   - .ss-reveal      → fades/slides in when scrolled into view
   - [data-ss-count] → counts a number up once visible (keeps any prefix/suffix)
   Safe to load once per page; re-scans on Shopify section reloads. */
(function () {
  if (window.__ssUpgrade) return;
  window.__ssUpgrade = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-ss-count'));
    if (isNaN(target) || reduce) return;
    var decimals = (String(el.getAttribute('data-ss-count')).split('.')[1] || '').length;
    var prefix = el.getAttribute('data-ss-prefix') || '';
    var suffix = el.getAttribute('data-ss-suffix') || '';
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + (target * eased).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-ss-count')) countUp(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function scan(root) {
    (root || document).querySelectorAll('.ss-reveal:not(.is-in), [data-ss-count]:not([data-ss-seen])').forEach(function (el) {
      el.setAttribute('data-ss-seen', '');
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  window.ssScan = scan;
})();
